<template>
  <DashboardCardTitle>
    <template #icon><v-img :src="termLifeCardIcon" height="40" width="55" alt="house" /></template>
    <template #title
      ><h2 :class="$vuetify.display.xs ? 'text-h2 mt-1' : 'text-h1'">
        {{ $t('L_term_life') }}
      </h2></template
    >
  </DashboardCardTitle>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import DashboardCardTitle from '@/modules/home/dashboard/components/DashboardCardTitle.vue';
import termLifeCardIcon from '@/assets/house-icon.svg';
import { mapStores } from 'pinia';
import { $t } from '@/i18n/i18n.ts';

export default defineComponent({
  name: 'TermLifeCardTitle',
  components: {
    DashboardCardTitle,
  },
  data: () => ({ termLifeCardIcon }),
  computed: {
    ...mapStores(usePolicyStore),
  },
  methods: {
    $t,
    _t(key: string): string {
      return this.$t(key + (this.policyStore.isPending ? '_application' : ''));
    },
  },
});
</script>
